import {toast} from 'react-toastify';
import {useSignOut} from 'api/generated';
import {usePersistentStore} from 'stores';
import {Button} from 'components';
import {useNavigate} from 'react-router-dom';

interface ISettingsSignOutProps {}

const SettingsSignOut = ({}: ISettingsSignOutProps) => {
  const impersonating = usePersistentStore(s => s.impersonating);
  const resetStore = usePersistentStore(s => s.reset);
  const navigate = useNavigate();

  const signOut = useSignOut();
  const handleSignOut = async () => {
    const {data: res} = await signOut.mutateAsync();
    if (res.data?.success) {
      resetStore();
      navigate('/sign-in', {replace: true});
    } else if (res.errors) {
      toast.error(res.errors[0].detail);
    }
  };

  return <Button text="Sign Out" onClick={handleSignOut} size="small" variant="alert" disabled={impersonating} loading={signOut.isPending} />;
};

export default SettingsSignOut;
